<template>
	<el-drawer ref="drawer" :with-header="false" size="50%" :before-close="handleClose" :visible.sync="dialogFormVisible"
	 direction="rtl" custom-class="demo-drawer">
		<div class="demo-drawer__content">
			<el-form ref="dataForm" :model="temp" label-position="left" label-width="70px" style="width: 100%; padding:10px; height: 100vh;overflow-y: scroll;">
				<el-tabs tab-position="top" style="height: 200px;">
					<el-tab-pane tabIndex=-1 label="基本信息">
						<el-form-item label="备注">
							<el-input v-model="temp.remarks" clearable />
						</el-form-item>
						<el-form-item label="昵称">
							<el-input v-model="temp.nickname" clearable />
						</el-form-item>
						<el-form-item label="手机号">
							<el-input v-model="temp.phone" clearable />
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
			</el-form>
			<div class="demo-drawer__footer" style="position:fixed;top:15px;right:30px;">
				<el-button size="mini" @click="$refs.drawer.closeDrawer()">取 消</el-button>
				<!-- <el-button size="mini" :loading="btnLoading" type="primary" @click="saveData()">保存</el-button> -->
				<el-button size="mini" :loading="btnLoading" type="primary" @click="saveMsg()">保存</el-button>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" :modal="false">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</el-drawer>
</template>

<script>
	// import Uploadone from '@/components/Upload/singleImage'
	import {
		userSave,
		userGetinfo
	} from '@/api/sc'
	import {
		getListAll
	} from '@/api/roles'
	import {
		formatImgToArr
	} from '@/utils'
	import myconfig from '@/settings.js'

	export default {
		name: 'userForm',
		components: {
			// Uploadone
		},
		data() {
			return {
				btnLoading: false,
				dialogVisible: false,
				dialogImageUrl: '',
				dialogFormVisible: false,
				needId:'',
				temp: {
					remarks:'',
					nickname:'',
					phone:'',
				},
			}
		},
		watch: {
			// dialogFormVisible: function() {
			// 	this.resetTemp()
			// },
			temp: {
				handler(newVal, oldVal) {

				},
				immediate: true,
				deep: true
			}
		},
		created() {
			// this.getRoles();
		},
		mounted() {

		},
		destroyed() {

		},
		methods: {
			handleClose(done) {
				if (this.btnLoading) {
					return
				}
				// this.$confirm('更改将不会被保存，确定要取消吗？')
				// 	.then(_ => {
				this.dialogFormVisible = false
				// })
				// .catch(_ => {})
			},
			// getRoles() {
			// 	getListAll().then(response => {
			// 		this.roles = response.data.data
			// 	})
			// },
			handleUpdate(id) {
				this.needId = id;
				this.btnLoading = false
				this.dialogFormVisible = true
				const _this = this
				var data = {
					id: id
				}
				userGetinfo(data).then(response => {
					console.log(response);
					if (response.code == 10000) {
						_this.temp.remarks = response.data.remarks;
						_this.temp.nickname = response.data.nickname;
						_this.temp.phone = response.data.phone;
					}
				})
			},
			createStateFilter(queryString) {
				return (state) => {
					return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.needVid = item.id;
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			//修改
			saveMsg(){
				var _this = this;
				var data = {
					id: this.needId,
					remarks:this.temp.remarks,
					nickname:this.temp.nickname,
					phone: this.temp.phone,
				};
				userSave(data).then(response => {
					if (response.code == 10000) {
						this.$emit('updateRow', 1)
						_this.dialogFormVisible = false
						_this.$message.success('修改成功')
					}
				})
			},
		},

	}
</script>
